function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon Design - Merged"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5 6h-14a.5.5 0 00-.5.5v14a.5.5 0 00.5.5h14a.5.5 0 00.5-.5v-14a.5.5 0 00-.5-.5zM17 20H4V7h13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5 3h-14a.5.5 0 000 1H20v13.5a.5.5 0 001 0v-14a.5.5 0 00-.5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 16.75a1.938 1.938 0 01-1.49-.757.5.5 0 10-.77.639A2.994 2.994 0 0010 17.704v.796a.5.5 0 001 0v-.803a2.379 2.379 0 001.875-2.322 2.382 2.382 0 00-1.526-2.01l-1.244-.622c-.623-.322-.98-.73-.98-1.118A1.377 1.377 0 0110.5 10.25a1.938 1.938 0 011.49.757.5.5 0 10.77-.639A2.994 2.994 0 0011 9.296V8.5a.5.5 0 00-1 0v.803a2.379 2.379 0 00-1.875 2.322 2.386 2.386 0 001.526 2.01l1.245.622c.622.321.979.73.979 1.118A1.377 1.377 0 0110.5 16.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})));